import axios from "axios";
import { $userInfoBd } from "../store/user";
import { defaultPath } from "./defaultPath";

export const card = {
    get: async (): Promise<string> => {
        const user_id = $userInfoBd.getState()?.id;
        const res = await axios.get(`${defaultPath}/users/${user_id}`);
        
        return res.data;
    },
    save: async (card_num:string) => {
        const user_id = $userInfoBd.getState()?.id;
        const res = await axios.post(`${defaultPath}connect_bank_card`,{user_id,card_num});

        return res.data;
    },
    change: async (card_num:string) => {
        const user_id = $userInfoBd.getState()?.id;
        const res = await axios.post(`${defaultPath}change_bank_card`,{user_id,card_num});

        return res.data;
    },
    delete: async () => {
        const user_id = $userInfoBd.getState()?.id;
        const res = await axios.post(`${defaultPath}delete_bank_card`,{user_id});

        return res.data;
    },
}